import { bianka, BIANKA_ACTIVITY_TYPES, logger } from '@fiverr-private/obs';
import { SellerProgramPlanDetails } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/seller_program_plan_details';

export const sendClickEventToBianka = async (clickData) => {
    try {
        await bianka.reportActivity({
            event: {
                type: clickData.event_type,
                clickType: 1,
                element: {
                    name: clickData.element_name ?? 'general_click',
                    type: 2,
                },
            },
            page: {
                name: 'header layout',
                ctxId: clickData.ctx_id,
            },
            additionalData: {
                message: {
                    sellerTeamAccount: {
                        accountId: clickData.account_id,
                        teamMember: {
                            memberId: clickData.member_id,
                        },
                    },
                },
                type: SellerProgramPlanDetails,
            },
            type: BIANKA_ACTIVITY_TYPES.CLICK,
        });
    } catch (error) {
        logger.error(error, { description: 'Failed to send click event in TeamAccountMember' });
    }
};
